import {
  CASES_CHANGE_FILTER_DATES,
  CASES_CHANGE_FILTER_FULLTEXT_SEARCH,
  CASES_CHANGE_FILTER_SERVICES,
  CASES_CHANGE_FILTER_SPECIALISTS,
  CASES_CHANGE_FILTER_STATUSES,
  CASES_RECEIVE,
  CASES_RESET_PAGE,
  CASES_START_LOADER,
  CASES_STOP_LOADER
} from '../mutations/available'

import api from '@/api'
import _ from 'lodash'

export const changeCasesFilterStatuses = async ({commit, dispatch}, statuses) => {
  commit(CASES_CHANGE_FILTER_STATUSES, statuses)
  dispatch('resetPage')
  dispatch('loadCases')
}

export const changeCasesFilterServices = async ({commit, dispatch}, serviceIds) => {
  commit(CASES_CHANGE_FILTER_SERVICES, serviceIds)
  dispatch('resetPage')
  dispatch('loadCases')
}

export const changeCasesFilterSpecialists = async ({commit, dispatch}, specialistIds) => {
  commit(CASES_CHANGE_FILTER_SPECIALISTS, specialistIds)
  dispatch('resetPage')
  dispatch('loadCases')
}

export const changeCasesFilterFulltextSearch = async ({commit, dispatch}, fulltextSearch) => {
  commit(CASES_CHANGE_FILTER_FULLTEXT_SEARCH, fulltextSearch)
  dispatch('resetPage')
  dispatch('loadCases')
}

export const changeCasesFilterDates = async ({commit, dispatch}, dates) => {
  commit(CASES_CHANGE_FILTER_DATES, dates)
  dispatch('resetPage')
  dispatch('loadCases')
}

/* eslint-disable no-empty-pattern */
export const checkMaterialExists = async ({state}, {code, caseId}) => {
  try {
    return await api.checkMaterialExists(code, caseId)
  } catch (e) {
    console.log(`Unable to check material exists`)
  }

  return false
}

export const resetPage = async ({commit}) => {
  commit(CASES_RESET_PAGE)
}

export const loadCases = _.debounce(async ({commit, state}) => {
  const {page, rowsPerPage} = state.cases.pagination

  commit(CASES_START_LOADER)
  try {
    let resultFilters = {
      ...state.cases.filters,
      clientId: state.currentClientId
    }
    let result = await api.getCases((page - 1) * rowsPerPage, rowsPerPage, resultFilters)
    commit(CASES_RECEIVE, {
      cases: result.cases,
      casesTotal: result.total
    })
  } catch (e) {
    console.log(e)
  }
  commit(CASES_STOP_LOADER)
}, 250)